import { history } from 'config'
import { useEffect } from 'react'

import { useAnalytics } from './useAnalytics'
import { normalizarRota } from './utils-analytics'

export function useAnalyticsPageview() {
  const { analytics } = useAnalytics()

  useEffect(() => {
    return history.listen((location) => {
      analytics.logPageview(normalizarRota(location.pathname))
    })
  }, [analytics])
}
